var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex justify-center" },
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              _vm.currentUser.clientType === "Media" ||
              _vm.currentUser.clientType === "Driblab"
                ? _c("MediaModeForm", {
                    attrs: {
                      fields: _vm.mediaModeFields,
                      mediaMode: _vm.mediaMode,
                      mediaModeData: _vm.mediaModeData,
                      mediaModeFlags: _vm.mediaModeFlags,
                      selectorMode: "",
                    },
                    on: {
                      mediaModeChange: function ($event) {
                        return _vm.onMediaModeChange($event)
                      },
                      mediaModeDataChange: function ($event) {
                        return _vm.onMediaModeDataChange($event)
                      },
                      mediaModeFlagsChange: function ($event) {
                        _vm.mediaModeFlags = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { elevation: "0", outlined: "" } },
                [
                  _c(
                    "v-card-actions",
                    { staticClass: "pb-0 pt-3" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "pa-0", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { id: "ranking-data" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column pb-1 align-start pl-4 pt-0",
                                  attrs: { cols: "12", sm: "4" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "pa-0 header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("general.filters")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "table.clientLeagues.seasons"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.loading
                                        ? _c("v-skeleton-loader", {
                                            staticClass: "mt-2",
                                            attrs: {
                                              type: "text",
                                              width: "200",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.loading
                                    ? _c("v-autocomplete", {
                                        staticClass: "w-90",
                                        attrs: {
                                          "hide-details": "",
                                          dense: "",
                                          clearable: "",
                                          items: _vm.playerSeasonDataFiltered,
                                          "item-value": "seasonId",
                                          "item-text": "compoundText",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onPlayerSeasonChange(
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "body-2 mb-1 w-90 black--text",
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          "lightSecondary lighten-2",
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          height: "20",
                                                          src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                        },
                                                        on: {
                                                          error: function (
                                                            $event
                                                          ) {
                                                            return _vm.onImageLoadFailure(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mx-1" },
                                                        [_vm._v("@")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.teamName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "pa-0 primary--text body-2 font-weight-medium d-flex align-center",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          height: "20",
                                                          contain: "",
                                                          src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                        },
                                                        on: {
                                                          error: function (
                                                            $event
                                                          ) {
                                                            return _vm.onImageLoadFailure(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-column",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.seasonName
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.teamName
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          521504991
                                        ),
                                        model: {
                                          value: _vm.seasonModel,
                                          callback: function ($$v) {
                                            _vm.seasonModel = $$v
                                          },
                                          expression: "seasonModel",
                                        },
                                      })
                                    : _c("v-skeleton-loader", {
                                        staticClass: "mt-2",
                                        attrs: { type: "text", width: "200" },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.$vuetify.breakpoint.smAndDown ||
                              _vm.showOptions
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "pl-4 pt-6",
                                      attrs: { cols: "12", sm: "4" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "header-font",
                                          staticStyle: { "font-size": "22px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("beeswarm.template")
                                            ) + "\n                  "
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "elevation-0 monospace-font white--text px-2",
                                              attrs: {
                                                small: "",
                                                rounded: "",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onNewTemplateClick()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "white",
                                                    small: "",
                                                  },
                                                },
                                                [_vm._v("add")]
                                              ),
                                              _vm._v(
                                                _vm._s(_vm.$t("general.new")) +
                                                  "\n                  "
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.loading
                                            ? _c("v-skeleton-loader", {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  type: "paragraph@2,text@2",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.loading
                                        ? _c(
                                            "v-radio-group",
                                            {
                                              staticClass:
                                                "mt-0 d-flex flex-column",
                                              attrs: {
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onTemplateChange()
                                                },
                                              },
                                              model: {
                                                value: _vm.templateActiveId,
                                                callback: function ($$v) {
                                                  _vm.templateActiveId = $$v
                                                },
                                                expression: "templateActiveId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.groupedTemplates,
                                              function (group, groupKey) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: groupKey,
                                                    staticClass: "mb-4",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mb-2 primary--text font-weight-bold subheader-font body-1",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "me-1",
                                                            style: `font-size: ${
                                                              _vm.getRadarTemplateSubtitle(
                                                                groupKey
                                                              ).size
                                                            }`,
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.getRadarTemplateSubtitle(
                                                                    groupKey
                                                                  ).icon
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getRadarTemplateSubtitle(
                                                                groupKey
                                                              ).label
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-row",
                                                        attrs: {
                                                          dense: "",
                                                          "no-gutters": "",
                                                          wrap: "",
                                                        },
                                                      },
                                                      _vm._l(
                                                        group,
                                                        function (template) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: template.radarId,
                                                              attrs: {
                                                                cols: "auto",
                                                              },
                                                            },
                                                            [
                                                              _c("v-radio", {
                                                                staticClass:
                                                                  "me-2 custom-radio",
                                                                style:
                                                                  _vm.getRadioStyle(
                                                                    template
                                                                  ),
                                                                attrs: {
                                                                  value:
                                                                    template.radarId,
                                                                  color:
                                                                    "secondary",
                                                                  disabled:
                                                                    (_vm.xyTemplateDisabled &&
                                                                      template.cXY) ||
                                                                    (_vm.physicalTemplateDisabled &&
                                                                      template.cPD) ||
                                                                    (_vm.arrigoTemplateDisabled &&
                                                                      template.cA),
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "label",
                                                                        fn: function () {
                                                                          return [
                                                                            _vm
                                                                              .player
                                                                              .isMale
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-1 primary--text font-weight-medium",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                              " +
                                                                                        _vm._s(
                                                                                          template.radarName
                                                                                            ? template.radarName
                                                                                            : _vm.$t(
                                                                                                `playerRecruitment.radarTemplates.${template.code}`
                                                                                              )
                                                                                        ) +
                                                                                        "\n                            "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-1 primary--text font-weight-medium",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                              " +
                                                                                        _vm._s(
                                                                                          template.radarName
                                                                                            ? template.radarName
                                                                                            : _vm.$t(
                                                                                                `playerRecruitment.radarTemplatesWomen.${template.code}`
                                                                                              )
                                                                                        ) +
                                                                                        "\n                            "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm.hasCustomRadars &&
                                                                            template.clientId ===
                                                                              0
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 body-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "(Driblab)"
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$vuetify.breakpoint.smAndDown ||
                              _vm.showOptions
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "pl-4 pt-0 pb-2",
                                      attrs: { cols: "12", sm: "4" },
                                    },
                                    [
                                      _c(
                                        "v-card-title",
                                        {
                                          staticClass: "pa-0 header-font",
                                          staticStyle: { "font-size": "22px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("beeswarm.compareWith")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mr-5 primary--text font-weight-bold body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "general.position"
                                                          )
                                                        ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.loading
                                                ? _c("v-skeleton-loader", {
                                                    staticClass: "mt-2",
                                                    attrs: { type: "text@3" },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.loading
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-wrap",
                                                    },
                                                    _vm._l(
                                                      _vm.allShortPositions,
                                                      function (
                                                        shortPosition,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "v-checkbox",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "w-30 mr-1 mt-0 py-1 body-2",
                                                            attrs: {
                                                              value:
                                                                shortPosition.fieldPositionId,
                                                              dense: "",
                                                              "hide-details":
                                                                "",
                                                              color:
                                                                "secondary",
                                                              disabled:
                                                                _vm
                                                                  .shortPositionsPlayedModel
                                                                  .length >=
                                                                  6 &&
                                                                !_vm.shortPositionsPlayedModel.includes(
                                                                  shortPosition.fieldPositionId
                                                                ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.onChangeInput(
                                                                  false
                                                                )
                                                              },
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex flex-column",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "body-1 primary--text font-weight-medium",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    `${_vm.getPositionCode(
                                                                                      shortPosition.fieldPositionId
                                                                                    )}`
                                                                                  ) +
                                                                                  " \n                              "
                                                                              ),
                                                                              shortPosition.minutesPlayed
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "body-2 primary--text",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                " +
                                                                                          _vm._s(
                                                                                            `(${shortPosition.minutesPlayed}')`
                                                                                          ) +
                                                                                          "\n                              "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.shortPositionsPlayedModel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.shortPositionsPlayedModel =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "shortPositionsPlayedModel",
                                                            },
                                                          }
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    _vm
                                                      .shortPositionsPlayedModel
                                                      .length == 6
                                                      ? "font-weight-bold red--text"
                                                      : "",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm
                                                          .shortPositionsPlayedModel
                                                          .length
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.gamePossessionMap.of"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(6) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "general.maximum"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mt-2 mb-0 primary--text font-weight-bold body-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "table.clientLeagues.seasons"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-autocomplete", {
                                            staticClass: "mt-0 pt-0 w-90",
                                            attrs: {
                                              items: _vm.seasonsClientFiltered,
                                              "item-text": "name",
                                              "item-value": "id",
                                              multiple: "",
                                              "hide-details": "",
                                              "return-object": "",
                                              clearable: "",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.onBlurSeasonInput(
                                                  $event
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.onChangeSeasonInput(
                                                  $event
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function ({
                                                    item,
                                                    index,
                                                  }) {
                                                    return [
                                                      index === 0
                                                        ? _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  "lightSecondary lighten-2",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "object",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.lId}.png`,
                                                                    type: "image/png",
                                                                    height:
                                                                      "20",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                      height:
                                                                        "20",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2 black--text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.name
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      index === 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "primary--text body-2 subheader-font",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(+" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .seasonsActiveObjFiltered
                                                                      .length -
                                                                      1
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "finishingMap.more"
                                                                    )
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list-item-avatar",
                                                        {
                                                          staticClass:
                                                            "d-flex align-center",
                                                        },
                                                        [
                                                          data.item.seasonIds
                                                            ? _c("v-icon", [
                                                                _vm._v("list"),
                                                              ])
                                                            : _c(
                                                                "object",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${data.item.lId}.png`,
                                                                    type: "image/png",
                                                                    height:
                                                                      "20",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                      height:
                                                                        "20",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    data.item
                                                                      .name
                                                                  ),
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3416334174
                                            ),
                                            model: {
                                              value:
                                                _vm.seasonsActiveObjFiltered,
                                              callback: function ($$v) {
                                                _vm.seasonsActiveObjFiltered =
                                                  $$v
                                              },
                                              expression:
                                                "seasonsActiveObjFiltered",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", { staticClass: "my-1" }),
                          _vm._v(" "),
                          !_vm.$vuetify.breakpoint.smAndDown || _vm.showOptions
                            ? _c(
                                "v-row",
                                { attrs: { id: "basic-filters" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex px-3",
                                      attrs: { cols: "12", sm: "3" },
                                    },
                                    [
                                      _c(
                                        "v-range-slider",
                                        {
                                          staticClass: "align-center px-1 py-0",
                                          attrs: {
                                            label: "Minutes",
                                            max: "5000",
                                            min: "0",
                                            step: "50",
                                            "hide-details": "",
                                            color: `secondary ${
                                              _vm.$vuetify.theme.dark
                                                ? "lighten-3"
                                                : ""
                                            }`,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChangeInput(false)
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "thumb-label",
                                                fn: function (props) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(props.value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            740749300
                                          ),
                                          model: {
                                            value: _vm.minutes,
                                            callback: function ($$v) {
                                              _vm.minutes = $$v
                                            },
                                            expression: "minutes",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text font-weight-bold body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "playerScout.minutes"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 subheader-font monospace-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        (" +
                                                        _vm._s(_vm.minutes[0]) +
                                                        "-" +
                                                        _vm._s(_vm.minutes[1]) +
                                                        ")\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex px-3",
                                      attrs: { cols: "12", sm: "3" },
                                    },
                                    [
                                      _c(
                                        "v-range-slider",
                                        {
                                          staticClass: "align-center px-1 py-0",
                                          attrs: {
                                            label: "Age",
                                            max: "50",
                                            min: "0",
                                            step: "1",
                                            "hide-details": "",
                                            color: `secondary ${
                                              _vm.$vuetify.theme.dark
                                                ? "lighten-3"
                                                : ""
                                            }`,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChangeInput(false)
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "thumb-label",
                                                fn: function (props) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(props.value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            740749300
                                          ),
                                          model: {
                                            value: _vm.age,
                                            callback: function ($$v) {
                                              _vm.age = $$v
                                            },
                                            expression: "age",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "primary--text font-weight-bold body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "playerScout.age"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "body-2 subheader-font monospace-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        (" +
                                                        _vm._s(_vm.age[0]) +
                                                        "-" +
                                                        _vm._s(_vm.age[1]) +
                                                        ")\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex px-3",
                                      attrs: { cols: "12", sm: "3" },
                                    },
                                    [
                                      _c(
                                        "v-range-slider",
                                        {
                                          staticClass: "align-center px-1 py-0",
                                          attrs: {
                                            label: "Height",
                                            max: "210",
                                            min: "120",
                                            step: "1",
                                            "hide-details": "",
                                            color: `secondary ${
                                              _vm.$vuetify.theme.dark
                                                ? "lighten-3"
                                                : ""
                                            }`,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChangeInput(false)
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "thumb-label",
                                                fn: function (props) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(props.value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            740749300
                                          ),
                                          model: {
                                            value: _vm.height,
                                            callback: function ($$v) {
                                              _vm.height = $$v
                                            },
                                            expression: "height",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "primary--text font-weight-bold body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "playerScout.height"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "body-2 subheader-font monospace-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        (" +
                                                        _vm._s(_vm.height[0]) +
                                                        "-" +
                                                        _vm._s(_vm.height[1]) +
                                                        ")\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex px-3",
                                      attrs: { cols: "12", sm: "3" },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mr-1 mt-0 py-1 body-2",
                                        attrs: {
                                          dense: "",
                                          "hide-details": "",
                                          color: "secondary",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChangeInput(false)
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "primary--text font-weight-bold body-1",
                                                        },
                                                        [_vm._v("Show Zeros")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        top: "",
                                                        color:
                                                          "lightSecondary lighten-4",
                                                        "max-width": "300",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "pl-1",
                                                                      attrs: {
                                                                        color:
                                                                          "secondary",
                                                                        small:
                                                                          "",
                                                                      },
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "info"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        4039679368
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-column align-center",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "black--text body-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "beeswarm.warningZeros"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          751072468
                                        ),
                                        model: {
                                          value: _vm.showZeros,
                                          callback: function ($$v) {
                                            _vm.showZeros = $$v
                                          },
                                          expression: "showZeros",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$vuetify.breakpoint.smAndDown || _vm.showOptions
                            ? _c(
                                "v-row",
                                { attrs: { id: "highlight-filters" } },
                                [
                                  _vm.teamsOnBeeswarm
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "py-0 px-5 d-flex flex-column align-start mt-2",
                                          attrs: { cols: "12", md: "3" },
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "pa-0 mb-0 body-1 font-weight-bold primary--text flex-shrink-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "beeswarm.highlightPlayersOf"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass: "pa-0 flex-shrink-1",
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                staticClass: "pa-0 body-2 mb-2",
                                                attrs: {
                                                  multiple: "",
                                                  "hide-details": "",
                                                  clearable: "",
                                                  items: _vm.teamsOnBeeswarm,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  placeholder:
                                                    _vm.$t("searchbar.teams"),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.onChangeInput(
                                                      false
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "selection",
                                                      fn: function ({
                                                        item,
                                                        index,
                                                      }) {
                                                        return [
                                                          index < 1
                                                            ? _c(
                                                                "v-chip",
                                                                {
                                                                  staticClass:
                                                                    "body-1 mb-1",
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "lightSecondary lighten-2",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      height:
                                                                        "16",
                                                                      contain:
                                                                        "",
                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                                    },
                                                                    on: {
                                                                      error:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onImageLoadFailure(
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          index === 1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "primary--text body-2 subheader-font",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "(+" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .teamsToHighlightPlayersModel
                                                                          .length -
                                                                          1
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "finishingMap.more"
                                                                        )
                                                                      ) +
                                                                      ")"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c("img", {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              height: "16",
                                                              contain: "",
                                                              src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                            },
                                                            on: {
                                                              error: function (
                                                                $event
                                                              ) {
                                                                return _vm.onImageLoadFailure(
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3734279477
                                                ),
                                                model: {
                                                  value:
                                                    _vm.teamsToHighlightPlayersModel,
                                                  callback: function ($$v) {
                                                    _vm.teamsToHighlightPlayersModel =
                                                      $$v
                                                  },
                                                  expression:
                                                    "teamsToHighlightPlayersModel",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.playersOnBeeswarm
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "py-0 px-5 d-flex flex-column align-start mt-2",
                                          attrs: { cols: "12", md: "3" },
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "pa-0 mb-0 body-1 font-weight-bold primary--text flex-shrink-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "beeswarm.highlightPlayers"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass: "pa-0 flex-shrink-1",
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                staticClass: "pa-0 body-2 mb-2",
                                                attrs: {
                                                  multiple: "",
                                                  "hide-details": "",
                                                  clearable: "",
                                                  items: _vm.playersOnBeeswarm,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  placeholder:
                                                    _vm.$t("searchbar.players"),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.onChangeInput(
                                                      false
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "selection",
                                                      fn: function ({
                                                        item,
                                                        index,
                                                      }) {
                                                        return [
                                                          index < 1
                                                            ? _c(
                                                                "v-chip",
                                                                {
                                                                  staticClass:
                                                                    "body-1 mb-1",
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "lightSecondary lighten-2",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      height:
                                                                        "16",
                                                                      contain:
                                                                        "",
                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                                    },
                                                                    on: {
                                                                      error:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onImageLoadFailure(
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          index === 1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "primary--text body-2 subheader-font",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "(+" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .playersToHighlightModel
                                                                          .length -
                                                                          1
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "finishingMap.more"
                                                                        )
                                                                      ) +
                                                                      ")"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr-3",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center mt-1",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  contain: "",
                                                                  width: "12",
                                                                  src:
                                                                    "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                                    item.teamId +
                                                                    ".png",
                                                                },
                                                                on: {
                                                                  error:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onImageLoadFailure(
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ml-1 body-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.tN
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1446334990
                                                ),
                                                model: {
                                                  value:
                                                    _vm.playersToHighlightModel,
                                                  callback: function ($$v) {
                                                    _vm.playersToHighlightModel =
                                                      $$v
                                                  },
                                                  expression:
                                                    "playersToHighlightModel",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamsOnBeeswarm
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "py-0 px-5 d-flex flex-column align-start mt-2",
                                          attrs: { cols: "12", md: "3" },
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "pa-0 mb-0 body-1 font-weight-bold primary--text flex-shrink-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerScout.excludeTeams"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass: "pa-0 flex-shrink-1",
                                            },
                                            [
                                              _c(
                                                "v-autocomplete",
                                                {
                                                  staticClass:
                                                    "pa-0 body-2 mb-2",
                                                  attrs: {
                                                    multiple: "",
                                                    "hide-details": "",
                                                    clearable: "",
                                                    items: _vm.teamsOnBeeswarm,
                                                    "item-text": "name",
                                                    "item-value": "id",
                                                    placeholder:
                                                      _vm.$t("searchbar.teams"),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      _vm.onExcludeTeamsClick()
                                                      _vm.onChangeInput(false)
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "selection",
                                                        fn: function ({
                                                          item,
                                                          index,
                                                        }) {
                                                          return [
                                                            index < 1
                                                              ? _c(
                                                                  "v-chip",
                                                                  {
                                                                    staticClass:
                                                                      "body-1 mb-1",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "lightSecondary lighten-2",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "mr-2",
                                                                      attrs: {
                                                                        height:
                                                                          "16",
                                                                        contain:
                                                                          "",
                                                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onImageLoadFailure(
                                                                              $event
                                                                            )
                                                                          },
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            index === 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "primary--text body-2 subheader-font",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(+" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .excludeTeamsModel
                                                                            .length -
                                                                            1
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "finishingMap.more"
                                                                          )
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "item",
                                                        fn: function ({
                                                          item,
                                                        }) {
                                                          return [
                                                            _c("img", {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                height: "16",
                                                                contain: "",
                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                              },
                                                              on: {
                                                                error:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onImageLoadFailure(
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "body-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    795092952
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.excludeTeamsModel,
                                                    callback: function ($$v) {
                                                      _vm.excludeTeamsModel =
                                                        $$v
                                                    },
                                                    expression:
                                                      "excludeTeamsModel",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        slot: "prepend-item",
                                                        ripple: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onExcludedSelectAllClick()
                                                        },
                                                      },
                                                      slot: "prepend-item",
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "finishingMap.selectAll"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "py-0 px-5 d-flex flex-column align-start mt-2",
                                      attrs: { cols: "12", md: "3" },
                                    },
                                    [
                                      _c(
                                        "v-card-title",
                                        {
                                          staticClass:
                                            "pa-0 mb-0 body-1 font-weight-bold primary--text flex-shrink-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("beeswarm.filterTeams")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-0 flex-shrink-1" },
                                        [
                                          _c(
                                            "v-autocomplete",
                                            {
                                              staticClass: "pa-0 body-2 mb-2",
                                              attrs: {
                                                multiple: "",
                                                "hide-details": "",
                                                clearable: "",
                                                items: _vm.teamsOnBeeswarm,
                                                "item-text": "name",
                                                "item-value": "id",
                                                placeholder:
                                                  _vm.$t("searchbar.teams"),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.onFilterTeamsClick()
                                                  _vm.onChangeInput(false)
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "selection",
                                                    fn: function ({
                                                      item,
                                                      index,
                                                    }) {
                                                      return [
                                                        index < 1
                                                          ? _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "body-1 mb-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "lightSecondary lighten-2",
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    height:
                                                                      "16",
                                                                    contain: "",
                                                                    src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onImageLoadFailure(
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "body-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        index === 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "primary--text body-2 subheader-font",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(+" +
                                                                    _vm._s(
                                                                      _vm
                                                                        .filterTeamsModel
                                                                        .length -
                                                                        1
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "finishingMap.more"
                                                                      )
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c("img", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            height: "16",
                                                            contain: "",
                                                            src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.id}.png`,
                                                          },
                                                          on: {
                                                            error: function (
                                                              $event
                                                            ) {
                                                              return _vm.onImageLoadFailure(
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.name)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3408134366
                                              ),
                                              model: {
                                                value: _vm.filterTeamsModel,
                                                callback: function ($$v) {
                                                  _vm.filterTeamsModel = $$v
                                                },
                                                expression: "filterTeamsModel",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    slot: "prepend-item",
                                                    ripple: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onFilterSelectAllClick()
                                                    },
                                                  },
                                                  slot: "prepend-item",
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "finishingMap.selectAll"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { id: "download-zone" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-end py-2 px-2",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text px-3 mx-1",
                                      attrs: {
                                        color: "secondary",
                                        rounded: "",
                                        small: "",
                                        "x-small":
                                          !_vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.saveAsPNG()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    file_download"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {}, [_vm._v("PNG")]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text px-3 mx-1",
                                      attrs: {
                                        color: "secondary",
                                        rounded: "",
                                        small: "",
                                        "x-small":
                                          !_vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.saveAsSVG()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("file_download"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("SVG")]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text px-3 mx-1",
                                      attrs: {
                                        color: "secondary",
                                        rounded: "",
                                        small: "",
                                        "x-small":
                                          !_vm.$vuetify.breakpoint.xsOnly,
                                        loading: _vm.loadingExport,
                                        disabled: !_vm.beeswarmLoaded,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.onGenerateIFrameClick()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("share")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Embed")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _vm.$vuetify.breakpoint.smAndDown
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex justify-center",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "px-4",
                                          attrs: {
                                            color: "primary",
                                            small: "",
                                            outlined: "",
                                            rounded: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showOptions = !_vm.showOptions
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "monospace-font body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.showOptions
                                                      ? "general.lessOptions"
                                                      : "general.moreOptions"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.showOptions
                                                    ? "keyboard_arrow_up"
                                                    : "keyboard_arrow_down"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.mediaMode && _vm.categoriesOfRadar.length
            ? _c(
                "v-col",
                {
                  staticClass: "d-flex px-3 pb-0 justify-center",
                  attrs: { id: "category-buttons", cols: "12" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-center" },
                    [
                      _c(
                        "v-chip",
                        {
                          staticClass: "mr-2 my-1 d-flex justify-center",
                          attrs: {
                            color: "secondary",
                            outlined: !_vm.allCategoriesSelected,
                            label: true,
                            small: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onAllCategoriesClick()
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-2 font-weight-medium monospace-font",
                            },
                            [_vm._v(_vm._s(_vm.$t("general.all")))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider", { attrs: { vertical: "" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex px-2 flex-wrap" },
                        _vm._l(_vm.categoriesOfRadar, function (category) {
                          return _c(
                            "v-chip",
                            {
                              key: category.id,
                              staticClass: "mr-2 my-1 d-flex justify-center",
                              attrs: {
                                outlined: !_vm.isHeaderActive(category),
                                color: "secondary",
                                label: true,
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onCategoryClick(category)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 font-weight-medium monospace-font",
                                },
                                [
                                  _vm._v(
                                    _vm._s(category.code) +
                                      " (" +
                                      _vm._s(category.count) +
                                      ")"
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "beeswarm",
              style: { "max-width": this.mediaMode ? "1185px" : "" },
              attrs: { cols: "12", md: "12" },
            },
            [
              !_vm.loading &&
              !_vm.mediaMode &&
              _vm.beeswarmDataFiltered.bees.length > 0
                ? _c(
                    "v-row",
                    { staticClass: "mx-1" },
                    _vm._l(
                      _vm.beeswarmDataFiltered.stats,
                      function (stat, index) {
                        return _vm.beeswarmDataFiltered.stats.length > 0
                          ? _c(
                              "v-col",
                              {
                                key: index,
                                staticClass:
                                  "text-start py-0 px-sm-3 mb-4 mt-1",
                                attrs: { cols: "12", md: "6" },
                              },
                              [
                                stat.name
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          bottom: "",
                                          color: "lightSecondary lighten-4",
                                          "max-width": "300",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c("div", [
                                                    _c(
                                                      "p",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "font-weight-bold mb-0",
                                                            staticStyle: {
                                                              "font-size":
                                                                "20px",
                                                            },
                                                          },
                                                          "p",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        stat.product &&
                                                        stat.product.icon
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                style:
                                                                  stat.product.icon.startsWith(
                                                                    "fa-"
                                                                  )
                                                                    ? "font-size: 14px"
                                                                    : "font-size: 18px",
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    stat.product
                                                                      .icon
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(stat.name) +
                                                            "\n                "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "body-1 subheader-font primary--text mb-0",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(stat.subtitle)
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-column black--text body-1",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [_vm._v(_vm._s(stat.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "monospace-font body-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(stat.product.name)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            stat.name !== stat.tooltip
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      stat.tooltip
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.size != 0 &&
                                _vm.seasonsActiveFiltered.length > 0
                                  ? _c("Beeswarm", {
                                      key: _vm.idKey,
                                      ref: "beeswarmRef",
                                      refInFor: true,
                                      attrs: {
                                        index: index,
                                        size: _vm.size,
                                        chartData:
                                          _vm.beeswarmDataFiltered.bees,
                                        playerId: parseInt(_vm.playerId),
                                        seasonId: _vm.seasonModel,
                                        teamId: _vm.seasonModelObj.teamId,
                                        statId: stat.id,
                                        stat: stat.code,
                                        reversedStat: stat.r,
                                        highlightPlayersOfTeamId:
                                          _vm.teamsToHighlightPlayersModel,
                                        highlightPlayersByPlayerId:
                                          _vm.playersToHighlightModel,
                                        excludeTeams: _vm.excludeTeamsModel,
                                        idKey: _vm.idKey,
                                        darkMode: _vm.darkMode,
                                        parentSVG: _vm.$refs.parentSVGRef,
                                        bgColor:
                                          _vm.beeswarmDefaultColors.bgColor,
                                        textColor:
                                          _vm.beeswarmDefaultColors.textColor,
                                        axisColor:
                                          _vm.beeswarmDefaultColors.axisColor,
                                        doTimeOut: _vm.doTimeOut,
                                        showZeros: _vm.showZeros,
                                      },
                                      on: {
                                        dataLoaded: function ($event) {
                                          return _vm.onBeeswarmDataLoaded(
                                            $event,
                                            stat.code
                                          )
                                        },
                                        circleOver: function ($event) {
                                          return _vm.onCircleOver($event)
                                        },
                                        circleOut: function ($event) {
                                          return _vm.onCircleOut($event)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e()
                      }
                    ),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading &&
              _vm.mediaMode &&
              _vm.beeswarmDataFiltered.bees.length > 0
                ? _c(
                    "v-row",
                    { staticClass: "mx-1" },
                    [
                      _vm.player && _vm.player.name
                        ? _c(
                            "v-col",
                            {
                              staticClass: "text-center px-0 py-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("PlayerAvatarMedia", {
                                ref: "playerAvatarMediaRef",
                                style: `background:${_vm.mediaModeData.bgColor}`,
                                attrs: {
                                  player: _vm.player,
                                  width: _vm.mediaModeData.comparisonPlayer
                                    ? _vm.avatarSize.width / 1.5
                                    : _vm.avatarSize.width,
                                  height: _vm.$vuetify.breakpoint.lgAndUp
                                    ? _vm.avatarSize.height
                                    : _vm.avatarSize.height * 0.44,
                                  id: _vm.player.playerId,
                                  title: _vm.mediaModeData.upperText,
                                  subtitle: _vm.mediaModeData.lowerText,
                                  color: _vm.mediaModeData.borderColor,
                                  bgColor: _vm.mediaModeData.bgColor,
                                  textColor: _vm.mediaModeData.textColor,
                                  face: _vm.mediaModeData.face
                                    ? _vm.mediaModeData.face.dataUrl
                                    : "",
                                  nationalTeam: _vm.mediaModeData.nationalTeam,
                                  lineDistance: _vm.mediaModeData.lineLength,
                                  avatarSize: _vm.mediaModeData.avatarSize,
                                  lineWeight: _vm.mediaModeData.lineWeight,
                                  comparisonFace: _vm.mediaModeData
                                    .comparisonFace
                                    ? _vm.mediaModeData.comparisonFace.dataUrl
                                    : "",
                                  comparisonPlayerData:
                                    _vm.mediaModeData.comparisonPlayer,
                                  comparisonTitle:
                                    _vm.mediaModeData.comparisonUpperText,
                                  comparisonSubtitle:
                                    _vm.mediaModeData.comparisonLowerText,
                                  comparisonColor:
                                    _vm.mediaModeData.comparisonBorderColor,
                                  upperTextFontSize:
                                    _vm.mediaModeData.upperTextFontSize,
                                  upperTextFontWeight:
                                    _vm.mediaModeData.upperTextFontWeight,
                                  lowerTextFontSize:
                                    _vm.mediaModeData.lowerTextFontSize,
                                  lowerTextFontWeight:
                                    _vm.mediaModeData.lowerTextFontWeight,
                                  fontFamily: _vm.mediaModeData.fontFamily,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.beeswarmDataFiltered.stats,
                        function (stat, index) {
                          return _c(
                            "v-col",
                            {
                              key: index,
                              staticClass: "text-center py-0 px-0",
                              attrs: { cols: "12" },
                            },
                            [
                              stat.name
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        bottom: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "p",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "font-weight-bold mb-0",
                                                        style: {
                                                          fontSize: "20px",
                                                          backgroundColor:
                                                            _vm.mediaModeData
                                                              .bgColor,
                                                          textColor:
                                                            _vm.mediaMode
                                                              .textColor,
                                                        },
                                                      },
                                                      "p",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    stat.product &&
                                                    stat.product.icon
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            style:
                                                              stat.product.icon.startsWith(
                                                                "fa-"
                                                              )
                                                                ? "font-size: 14px"
                                                                : "font-size: 18px",
                                                            attrs: {
                                                              color: "primary",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                stat.product
                                                                  .icon
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(stat.name) +
                                                        "\n              "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "mb-0",
                                                    style: {
                                                      fontSize: "14px",
                                                      backgroundColor:
                                                        _vm.mediaModeData
                                                          .bgColor,
                                                      textColor:
                                                        _vm.mediaMode.textColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(stat.subtitle)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column black--text body-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v(_vm._s(stat.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "monospace-font body-2",
                                            },
                                            [_vm._v(_vm._s(stat.product.name))]
                                          ),
                                          _vm._v(" "),
                                          stat.name !== stat.tooltip
                                            ? _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    stat.tooltip
                                                  ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.size != 0 &&
                              _vm.seasonsActiveFiltered.length > 0
                                ? _c("Beeswarm", {
                                    ref: "beeswarmRef",
                                    refInFor: true,
                                    attrs: {
                                      index: index,
                                      size: _vm.$vuetify.breakpoint.lgAndUp
                                        ? _vm.size * 1.155
                                        : _vm.size * 0.5,
                                      chartData: _vm.beeswarmDataFiltered.bees,
                                      playerId: parseInt(_vm.playerId),
                                      seasonId: _vm.seasonModel,
                                      teamId: _vm.seasonModelObj.teamId,
                                      statId: stat.id,
                                      stat: stat.code,
                                      reversedStat: stat.r,
                                      highlightPlayersOfTeamId:
                                        _vm.teamsToHighlightPlayersModel,
                                      highlightPlayersByPlayerId:
                                        _vm.playersToHighlightModel,
                                      excludeTeams: _vm.excludeTeamsModel,
                                      idKey: _vm.idKey,
                                      darkMode: _vm.darkMode,
                                      parentSVG: _vm.$refs.parentSVGRef,
                                      bgColor: _vm.mediaModeData.bgColor,
                                      textColor: _vm.mediaModeData.textColor,
                                      axisColor: _vm.mediaModeData.axisColor,
                                      comparisonPlayer:
                                        _vm.mediaModeData.comparisonPlayer,
                                      dotColor: _vm.mediaModeData.borderColor,
                                      comparisonDotColor:
                                        _vm.mediaModeData.comparisonBorderColor,
                                      mediaMode: _vm.mediaMode,
                                      doTimeOut: _vm.doTimeOut,
                                      fontFamily: _vm.mediaModeData.fontFamily,
                                      showZeros: _vm.showZeros,
                                      logoCfg: "none",
                                    },
                                    on: {
                                      sizeChange: function ($event) {
                                        return _vm.onBeeswarmSizeChange($event)
                                      },
                                      dataLoaded: function ($event) {
                                        return _vm.onBeeswarmDataLoaded(
                                          $event,
                                          stat.code
                                        )
                                      },
                                      circleOver: function ($event) {
                                        return _vm.onCircleOver($event)
                                      },
                                      circleOut: function ($event) {
                                        return _vm.onCircleOut($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm.player &&
                      _vm.avatarSize &&
                      _vm.chartSize &&
                      _vm.mediaMode &&
                      _vm.mediaModeData.socialMedia
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0 text-center",
                              style: `background-color:${_vm.mediaModeData.bgColor}`,
                              attrs: { cols: "12" },
                            },
                            [
                              _c("DriblabSocialMedia", {
                                ref: "driblabSocialMediaRef",
                                attrs: {
                                  width: _vm.chartSize.width,
                                  height: 50,
                                  id: _vm.player.playerId,
                                  bgColor: _vm.mediaModeData.bgColor,
                                  textColor: _vm.mediaModeData.textColor,
                                  fontSize:
                                    _vm.mediaModeData.socialMediaFontSize,
                                  fontWeight:
                                    _vm.mediaModeData.socialMediaFontWeight,
                                  logoCfg: _vm.mediaModeData.logo,
                                  type: "beeswarm",
                                  sponsor: _vm.mediaModeData.sponsor.dataUrl,
                                  fontFamily: _vm.mediaModeData.fontFamily,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "text-center d-flex align-center justify-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 75,
                              color: "secondary",
                              indeterminate: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("RadarTemplateFormModal", {
        ref: "formModalRef",
        attrs: {
          title: this.$t("settings.radarTemplates"),
          subtitle: this.$t("settings.radarTemplatesSubtitle"),
          positionId: _vm.player.positionId,
        },
        on: {
          save: function ($event) {
            return _vm.loadTemplates()
          },
        },
      }),
      _vm._v(" "),
      _c("ChartExportLinksModal", {
        ref: "chartExportLinksModalRef",
        attrs: { title: _vm.player.name, subtitle: "Beeswarm" },
      }),
      _vm._v(" "),
      _vm.currentUser.showTour
        ? _c("Tour", {
            attrs: { name: "playerBeeswarmTour", steps: _vm.tourSteps },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }